import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { selectCurrentLocation } from '../../../stores/locations/locations.selector';
import { selectAllRooms, selectCurrentRoom } from '../../../stores/rooms/rooms.selector';
import { RoomAddModalComponent } from '../room-add-modal/room-add-modal.component';

@Component({
  selector: 'era-room-selector',
  templateUrl: './room-selector.container.html',
  styleUrls: ['./room-selector.container.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, RouterLink],
})
export class RoomSelectorContainerComponent {
  private readonly store = inject(Store);
  private readonly modalService = inject(NgbModal);

  public readonly room = this.store.selectSignal(selectCurrentRoom);
  public readonly rooms = this.store.selectSignal(selectAllRooms);
  public readonly location = this.store.selectSignal(selectCurrentLocation);

  public openAddRoomModal(): void {
    this.modalService.open(RoomAddModalComponent);
  }
}
